import { makeStyles, tokens, typographyStyles } from "@fluentui/react-components";

import { InputSectionState } from "./InputSection.types";

const useStyles = makeStyles({
  fieldSet: {
    // clear the default border & padding for fieldset elements, we're just using them for the semantics not their styles.
    border: 'none',
    paddingLeft: 0,
    "& label": {
      ...typographyStyles.caption1,
      color: tokens.colorNeutralForeground3
    },
    marginBottom: tokens.spacingVerticalM
  },
  legend: {
    ...typographyStyles.subtitle2,
    marginBottom: 0,
    padding: 0,
  },
  description: {
    ...typographyStyles.caption1,
    marginBottom: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground3,
  }
});

export function applyStyles(state: InputSectionState) {
  const classes = useStyles();
  if (state.description) {
    state.description.className = classes.description;
  }

  state.root.className = classes.fieldSet;
  state.legend.className = classes.legend;
}
